import {
  tabCloser,
  tabIcons,
  tabTemplate,
  categoryCodeTab,
} from '@/layout/state/state';
import { matchSingleUrl } from '@/constants/urls';
import { closeAudits } from '../actions';
import AuditsActions from '../components/AuditsActions';
import AuditsPanel from '../components/AuditsPanel';

export default (urls, access, entity = '') => ({
  ...tabTemplate('audits', AuditsPanel, matchSingleUrl([...urls, 'audits']), AuditsActions),
  ...tabCloser('closeAuditsTab', closeAudits),
  ...tabIcons('history'),
  access,
  componentState: ({ args, url }) => categoryCodeTab(url, args[2], entity),
  order: 600,
  position: 'bottom-right',
});
